import React from "react";
import { useLocation, NavLink } from "react-router-dom";

import { Nav } from "react-bootstrap";
import logo from '../../assets/images/logo.png'; 

function Sidebar({ color, image, routes }) {
  const location = useLocation();
  const activeRoute = (routeName) => {
    return location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };
  return (
    <div className="sidebar" data-image={image} data-color={color}>
      <div
        className="sidebar-background"
        // Style is needed to set the background image
        style={{
          backgroundImage: "url(" + image + ")",
        }}
      />
      <div className="sidebar-wrapper">
        <div className="logo d-flex align-items-center justify-content-start">
          <a
            href="https://meaplatform.com"
            className="simple-text logo-mini mx-1"
          >
            <div className="logo-img">
              {/* <img
                src={require("assets/images/logo.png").default}
                alt="..."
              /> */}
              <img
                src={logo}
                alt="..."
              />
            </div>
            <span className="logo-caption">platform</span>
          </a>
        </div>
        <Nav>
          {routes.map((prop, key) => {
            if(prop.separator === true) {
              return <hr key={key} className="MuiDivider-root MuiDivider-fullWidth MuiDivider-light css-6vm7vh"></hr>;
            }
            if (!prop.redirect)
              return (
                <li
                  className={
                    prop.upgrade
                      ? "active active-pro"
                      : activeRoute(prop.layout + prop.path)
                  }
                  key={key}
                >
                  <NavLink
                    to={prop.layout + prop.path}
                    className={({ isActive }) => 
                      "nav-link" + (isActive ? " active" : "")
                    }
                    id={prop.name}
                  >
                    <i className={prop.icon} />
                    <p>{prop.name}</p>
                  </NavLink>
                </li>
              );
            return null;
          })}
        </Nav>
      </div>
    </div>
  );
}

export default Sidebar;
